import { common } from '@kurtosys/ksys-app-template';

export function logLevel(): number {
	const value = getKsysAppDebug();
	switch (value) {
		case 'true':
		case 'debug':
			return 0;
		case 'warn':
			return 1;
		case 'success':
			return 2;
		case 'info':
			return 3;
		case 'error':
		default:
			return -1;
	}
}

function getKsysAppDebug(): string | undefined {
	return common.commonUtils.getQueryStringValue({ key: 'ksysAppDebug' }, window.location.search);
}
